<template>
  <div class="view--stock">
    <loader v-if="loader"></loader>

    <header class="header">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-lg-4">
          <nav class="nav">
            <router-link :to="{ name: backRouteName }" tag="div" class="back">
              <i class="material-icons icon">chevron_left</i>
            </router-link>
            <h1 class="title">{{ $t(titleKey) }}</h1>
            <div class="placeholder"></div>
          </nav>
        </div>
      </div>
    </header>

    <main v-cloak>
      <div class="row justify-content-center flex-column align-items-center">
        <div class="col col-md-6 col-lg-4">
          <stock-filter
            :cities="cities"
            :branches="branches"
            :rewards-options="filterRewards"
            @change-city="onChangeCity"
            @submit="onFilterSubmit"
            @reset="onFilterReset"
          />

          <stock-table
            :items="rewards"
          />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Axios from '@/helpers/axios';
import Loader from '@/components/Loader.vue';
import StockFilter from '@/components/StockFilter.vue';
import StockTable from '@/components/StockTable.vue';

export default {
  name: 'StockPageBase',
  components: {
    Loader,
    StockFilter,
    StockTable,
  },
  props: {
    backRouteName: {
      type: String,
      required: true,
    },
    titleKey: {
      type: String,
      required: true,
    },
    fetchStock: {
      type: Function,
      required: true,
    },
    fetchProducts: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'brand',
      'client',
      'loader',
    ]),
  },
  data() {
    return {
      filterRewards: [],
      cities: [],
      branches: [],
      rewards: [],
    };
  },
  async beforeMount() {
    this.setLoader(true);

    try {
      await Promise.all([
        this.getStock(),
        this.getCities(),
        this.getProducts(),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoader(false);
    }
  },
  methods: {
    ...mapMutations(['setLoader']),
    async getStock(filters = {}) {
      this.rewards = [];

      try {
        const data = await this.fetchStock({
          filters,
          route: this.$route,
          client: this.client,
          i18n: this.$i18n,
        });
        this.rewards = data || [];
      } catch (error) {
        console.error(error);
      }
    },
    async getCities() {
      const data = {
        ...this.$route.query,
        p: this.client.phoneType,
        dtk: this.client.dtk,
        brand_id: this.$route.params.brand,
        lang: this.$i18n.locale,
      };

      try {
        const response = await Axios.post('/brand/getStoreGroupList', data);
        this.cities = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getStore(city) {
      const data = {
        ...this.$route.query,
        p: this.client.phoneType,
        dtk: this.client.dtk,
        brand_id: this.$route.params.brand,
        group: city,
        lang: this.$i18n.locale,
      };

      try {
        const response = await Axios.post('/brand/getStoreListByStoreGroup', data);
        this.branches = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getProducts() {
      try {
        const data = await this.fetchProducts({
          route: this.$route,
          client: this.client,
          i18n: this.$i18n,
        });
        this.filterRewards = data || [];
      } catch (error) {
        console.error(error);
      }
    },
    onChangeCity(city) {
      if (city) {
        this.getStore(city);
      } else {
        this.branches = [];
      }
    },
    onFilterSubmit(filters) {
      this.getStock(filters);
    },
    onFilterReset() {
      this.getStock({});
    },
  },
};
</script>

<style lang="sass" scoped>
.view--stock
  width: 100%
  height: 100%
  position: relative

  .btn
    border: none

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: black

  color: white

  .nav
    display: flex
    flex-wrap: nowrap

  .back
    height: 24px
    float: left

    cursor: pointer

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0
    overflow: hidden

    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px
    white-space: nowrap
    text-overflow: ellipsis

  .placeholder
    width: 36px

  .material-icons
    margin-right: 4px
    vertical-align: middle

main
  padding: 58px 0 80px

  &.in-app
    padding: 0 0 80px
</style>
